import { ceil as _ceil, floor as _floor } from 'lodash';

export function findActiveSectionOnMobile(panelRef, sectionElements) {
  if (panelRef.current && sectionElements && sectionElements.length > 1) {
    const elementRect = panelRef.current.getBoundingClientRect();

    const sections = Array.from(sectionElements).map((node, index) => {
      const nodeRect = node.getBoundingClientRect();
      return {
        index,
        nodeRect,
      };
    });

    sections.reverse();

    const lastVisibleSectionInReversedArray = sections.findIndex((section) => {
      const { nodeRect } = section;
      return nodeRect.bottom < elementRect.top;
    });

    if (lastVisibleSectionInReversedArray > -1) {
      return sections[lastVisibleSectionInReversedArray].index;
    }
  }
  return 0;
}

export function findActiveSectionOnDesktop(sectionElements) {
  const numberOfSections = sectionElements.length;
  const scrollThreshold = _ceil(
    (document.documentElement.scrollHeight - window.innerHeight) /
      numberOfSections
  );

  if (!scrollThreshold) {
    /*
     * If no scrollbar available (scrollHeight === window.innerHeight)
     * select first element
     */
    return 0;
  }

  const sectionIndex = Math.max(
    0,
    Math.min(
      _floor(document.documentElement.scrollTop / scrollThreshold),
      numberOfSections - 1
    )
  );
  return sectionIndex;
}
